__turbopack_context__.v({
  "author": "article-byline-module-scss-module__reyc9W__author",
  "avatar": "article-byline-module-scss-module__reyc9W__avatar",
  "byline": "article-byline-module-scss-module__reyc9W__byline",
  "name": "article-byline-module-scss-module__reyc9W__name",
  "skeleton": "article-byline-module-scss-module__reyc9W__skeleton",
});
